import { render, staticRenderFns } from "./SidebarMenuLink.vue?vue&type=template&id=416cf91a&"
import script from "./SidebarMenuLink.vue?vue&type=script&lang=js&"
export * from "./SidebarMenuLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SidebarMenuLink.vue"
export default component.exports